export class ContractCancelInput{

    productId:number;
    contractId:number;
    coverageId:number;
    cancelDate:string;
    kilometers:number;
    remarks:string;
    cancellationReason:string;
    dealerEmail:string;
    sellerEmail:string;
    sellerCode:string;
}